import React, { useEffect, useState } from 'react';
import { globalHistory } from '@reach/router';
import http from '../../../services/http.service';
import PropertyDetailsTitle from '../PropertyDetailsTitle/PropertyDetailsTitle';
import PropertyDetailsInfo from '../PropertyDetailsInfo/PropertyDetailsInfo';
import Gallery from '../../Gallery/Gallery';
import Spinner from '../../UI/Spinner/Spinner';
import BookmarkIcon from '../../../assets/img/icons/ic_bookmark_default.svg';
import ShareIcon from '../../../assets/img/icons/share.svg';
import DropdownCommon from '../../Dropdown/DropdownCommon/DropdownCommon';
import ModalCopy from '../../UI/ModalCopy/ModalCopy';
import MoreIcon from '../../../assets/img/icons/ic-more.svg';
import styles from './PropertyDetailsSearchResult.module.scss';
import { API } from '../../../constans/http';
import {
  getQueryParams,
  toggleBodyStylesForModal,
} from '../../../helpers/helper-methods';
import { SHARED_RESULTS_PATH } from '../../../constans/links';
import PropertyReviewDetails from '../../PropertyReviewDetails/PropertyReviewDetails';
import ReviewDetailsSEO from '../../ReviewDetailsSEO/ReviewDetailsSEO';

function PropertyDetailsSearchResult({
  containerClasses,
  propertyId,
  onAllOffersClick,
  galleryInnerStyles,
  detailsView,
}) {
  const [propertyData, setPropertyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [shareLink, setShareLink] = useState();
  const [showShareModal, setShowShareModal] = useState(false);

  const createShareLink = () => {
    const paramsObj = new URLSearchParams();
    const {
      requestId,
      checkin,
      checkout,
      currency,
      kidGuests,
      adultGuests,
      numberOfRooms,
    } = getQueryParams(`${globalHistory.location.search}`);
    const paramsToAdd = {
      requestId,
      propertyId,
      checkin,
      checkout,
      currency,
      kidGuests,
      adultGuests,
      numberOfRooms,
    };

    Object.keys(paramsToAdd).forEach((key) => {
      paramsObj.append(key, paramsToAdd[key]);
    });

    setShareLink(
      `${
        globalHistory.location.origin
      }${SHARED_RESULTS_PATH}?${paramsObj.toString()}`
    );
  };

  useEffect(() => {
    setLoading(true);
    if (propertyId) {
      http
        .get(`${API.PROPERTIES}/${propertyId}`)
        .then(({ data }) => {
          setPropertyData(data);
          setLoading(false);
        })
        .catch(() => setLoading(false));
      createShareLink();
    }
  }, [propertyId]);

  const toggleShareModal = () => {
    toggleBodyStylesForModal();
    setShowShareModal(!showShareModal);
  };

  return (
    <div className={`${containerClasses} ${styles.detailsWrapper}`}>
      {loading ? (
        <Spinner spinnerClasses="spinner-primary" />
      ) : (
        <>
          <ModalCopy
            copiedString={detailsView ? window?.location?.href : shareLink}
            displayToggle={toggleShareModal}
            show={showShareModal}
          />
          <PropertyDetailsTitle propertyData={propertyData}>
            <div
              className={`${styles.titleActionsBtnWrapper} flex flex-v-center flex-shrink-0`}
            >
              <ShareIcon
                className={`${styles.titleIcon} ${styles.shareIcon}`}
                onClick={toggleShareModal}
              />
              <BookmarkIcon
                className={`${styles.titleIcon} ${styles.bookMarkIcon}`}
              />
            </div>
            <DropdownCommon
              dropdownMainWrapperStyles={styles.dropdownMainWrapper}
              togglerContent={<MoreIcon className={styles.moreIcon} />}
              dropdownContentStyles={styles.dropdownContainer}
            >
              <div
                className={`${styles.dropdownItem} t-500`}
                onClick={toggleShareModal}
              >
                Share
              </div>
              <div className={`${styles.dropdownItem} t-500`}>
                Add to bookmark
              </div>
              {!detailsView && (
                <div
                  className={`${styles.dropdownItem} t-500`}
                  onClick={onAllOffersClick}
                >
                  All Offers
                </div>
              )}
            </DropdownCommon>
          </PropertyDetailsTitle>
          {propertyData.photos && (
            <Gallery
              bigImageStyles={styles.galleryBigImage}
              galleryInnerStyles={galleryInnerStyles}
              images={propertyData.photos}
            />
          )}
          <PropertyDetailsInfo
            propertyData={propertyData}
            foodImageStyles={styles.foodImageItem}
            propertyId={propertyData.id}
          />
          <PropertyReviewDetails propertyId={propertyData.id} />
        </>
      )}
    </div>
  );
}

PropertyDetailsSearchResult.defaultProps = {
  containerClasses: '',
  foodImageStyles: '',
};

export default PropertyDetailsSearchResult;
